<template>
  <div v-loading="loading" element-loading-text="加载中..." class="app-container">
    <el-card shadow="never">
      <el-form ref="detailForm" :model="detail" :rules="rules" label-width="100px" :label-position="device === 'mobile' ? 'top' : 'right'">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="23">
            <el-form-item label="标题" prop="title">
              <el-input v-model.trim="detail.title" placeholder="请输入文章标题" clearable />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :xs="24" :md="11">
            <el-form-item label="分类" prop="articleType">
              <el-select v-model="detail.articleType" placeholder="请选择文章分类" clearable>
                <el-option v-for="(item, index) in articleType" :key="index" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="6">
            <el-form-item label="状态" prop="status" class="inline-form-item">
              <el-switch v-model="detail.status" :width="60" class="rectangle" active-color="#13ce66" :active-value="1" :inactive-value="0" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="6">
            <el-form-item label="弹窗显示" prop="isPopup" class="inline-form-item">
              <el-switch v-model="detail.isPopup" :width="60" class="rectangle" active-color="#13ce66" :active-value="1" :inactive-value="0" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :xs="24" :sm="23">
            <el-form-item label="内容摘要" prop="summary">
              <el-input v-model.trim="detail.summary" type="textarea" autosize placeholder="请输入内容摘要" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="23">
            <el-form-item label="文章内容" prop="planText">
              <my-editor v-model="detail.content" :text.sync="detail.planText" :images.sync="editorImages" :not-exists.sync="deletedImages" :auto-focus="false" @change="editorChange" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <div class="app-form-button-group">
      <el-button icon="el-icon-back" @click="onBack">返回列表</el-button>
      <el-button type="info" @click="onCreateArticle">新增文章</el-button>
      <el-button type="primary" @click="onSubmit">提交保存</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { uploadFile } from '@/api/oss'
import { getArticleDetail, submitArticleDetail } from '@/api/article'

export default {
  name: 'ArticleEdit',
  components: {
    MyEditor: () => import('@/components/MyEditor')
  },
  data() {
    return {
      loading: false,
      articleId: '',
      detail: {},
      rules: {
        articleType: [{ required: true, message: '请选择文章分类', trigger: 'change' }],
        planText: [{ required: true, message: '请输入文章内容', trigger: 'change' }]
      },
      editorImages: [],
      deletedImages: [],
      articleType: [
        { id: 11, name: '首页公告', type: '' },
        { id: 12, name: '优品商城公告', type: '' },
        { id: 13, name: '福利商城公告', type: '' },
        { id: 14, name: '本地商家公告', type: '' },
        { id: 2, name: '新人手册', type: 'warning' },
        { id: 3, name: '资讯', type: 'info' },
        { id: 5, name: '用户协议', type: 'danger' },
        { id: 6, name: '隐私政策', type: 'danger' },
        { id: 7, name: '退货政策', type: 'danger' }
      ]
    }
  },
  computed: {
    ...mapState({
      device: state => state.app.device
    })
  },
  created() {
    this.articleId = this.$route.query.articleId || undefined
    if (this.articleId) this.loadData()
    else this.initData()
  },
  methods: {
    initData() {
      this.loading = true
      this.detail = Object.assign({}, {
        id: undefined,
        articleType: undefined,
        title: undefined,
        cover: undefined,
        summary: undefined,
        content: undefined,
        publishDate: undefined,
        status: 0,
        isPopup: 0,
        planText: ''
      })
      this.editorImages = []
      this.deletedImages = []
      this.$nextTick(() => {
        this.$refs.detailForm.resetFields()
      })
      this.$util.delay(500).then(() => { this.loading = false })
    },
    editorChange() {
      this.$refs.detailForm.validateField('planText')
    },
    loadData() {
      this.loading = true
      getArticleDetail(this.articleId).then(response => {
        this.detail = response
      }).finally(() => {
        this.$util.delay(500).then(() => { this.loading = false })
      })
    },
    onBack() {
      this.$store.dispatch('tagsView/delView', this.$route)
      const from = this.$route.query.from || ''
      if (from === 'list') {
        this.$router.go(-1)
      } else {
        this.$router.push({ path: `/article/index` })
      }
    },
    onCreateArticle() {
      this.initData()
    },
    uploadImages() {
      return new Promise((resolve, reject) => {
        const uploadPromises = []

        this.deletedImages.forEach(item => {
          const index = this.editorImages.findIndex(img => img.url === item.url)
          this.editorImages.splice(index, 1)
        })
        const editorFiles = this.editorImages.filter(item => !!item.file)
        if (editorFiles && editorFiles.length) editorFiles.forEach(item => uploadPromises.push(uploadFile(item.file)))

        if (uploadPromises && uploadPromises.length) {
          Promise.all(uploadPromises).then(response => {
            if (editorFiles && editorFiles.length) {
              editorFiles.forEach((item, index) => {
                const oIndex = this.editorImages.findIndex(img => img.url === item.url)
                if (oIndex >= 0) {
                  item = Object.assign({}, item, { url: response[index], file: undefined })
                  this.editorImages.splice(oIndex, 1, item)
                }
              })
            }
            this.editorImages.forEach(item => {
              this.detail.content = `${this.detail.content}`.replace(item.old, item.url)
            })
            resolve()
          }).catch(() => reject('图片上传失败'))
        } else {
          resolve()
        }
      })
    },
    onSubmit() {
      this.$refs.detailForm.validate(valid => {
        if (!valid) return false

        this.loading = true
        // 上传商品图片
        this.uploadImages().then(() => {
          delete this.detail.planText
          return submitArticleDetail(this.detail)
        }).then(response => {
          this.detail = response
          this.$util.delay(500).then(() => {
            this.loading = false
            this.$confirm('文章保存成功，是否继续添加？', '温馨提示', {
              confirmButtonText: '继续添加',
              cancelButtonText: '返回列表',
              type: 'success'
            }).then(() => this.onCreateArticle()).catch(() => this.onBack())
          })
        }).catch(() => {
          this.$message.error('文章提交保存失败')
          this.loading = false
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
